var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"system-info"},_vm._l((_vm.displayItems),function(displayItem){return _c('div',{key:displayItem.heading,staticClass:"line"},[_c('CaseFieldItem',{attrs:{"heading":displayItem.heading,"value":displayItem.value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }